"use client"

import type { FunctionComponent } from "react"

import { useTranslation } from "@/modules/i18n/components/useTranslation"

import { StandardError } from "./StandardError"

type StandardErrorWithLazyTitleProps = {
  errorId: string
}

export const StandardErrorWithLazyTitle: FunctionComponent<StandardErrorWithLazyTitleProps> = ({ errorId }) => {
  const { t, ready } = useTranslation(["shared_server"], true)

  const title = ready ? t("shared_server.error_pages.internal_error.message") : "Internal server error"

  return <StandardError title={title} errorId={errorId} />
}
